<!--Desktop View-->
<div class="downloads-main content-web-section">
  <div class="col-12 row" *ngIf="topicList.length>0">
    <div class="col-3 tabs-section">
      <div *ngFor="let item of topicList;let i=index">
        <div class="question-tabs cursor-pointer" (click)="setActiveTopic(i)"
          [ngClass]="{'active-tab-button2':i===activeTopicId && !assetCheck}">
          <a class="tab-btn-text2">{{item.topic}}</a>
        </div>
      </div>
    </div>
    <ng-template [ngIf]="!assetCheck">
    <div class="col-9 answer-section">
    <div class="article-heading2">{{ topicList[activeTopicId].topic}} </div>
      <div class="answwer-content">
        <div *ngFor="let item of activePageDataChunk">
          <div class="col-12">
            <div class="col-12 pl-0">
              <!---FOR OTHER THEN DIGITAL FACTSHEET-->
              <div *ngIf="topicList[activeTopicId].topic!==digitalFactSheetTitle" class="col-12 row file-list-section ">
                <div class="col-9 ">
                  <div class="text-answer-section">
                     {{item.fileName}} 
                  </div>
                </div>
                <div class="col-3">
                  <img src="assets/icons/icon_view.png" class="view-img cursor-pointer" (click)=viewFile(item.url)>
                  &nbsp; <span class="tab-seperator"></span> &nbsp;
                    <file-download [path]="item.url"></file-download>
                </div>
              </div>
              <!--- DIGITAL FACTSHEET-->
              <div *ngIf="topicList[activeTopicId].topic===digitalFactSheetTitle" class="col-12 row file-list-section ">
                <div class="col-9 ">
                  <div class="text-answer-section">
                     {{item?.digitalFactsheetTitle}} 
                  </div>
                </div>
                <div class="col-3 text-right">
                  <img src="assets/icons/icon_view.png" class="view-img cursor-pointer" (click)=viewFile(item.digitalFactsheetUrl)>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngFor="let item of topicList;let i=index">
        <mat-paginator  *ngIf="i===activeTopicId" class="paginator-bg" [length]="topicList[activeTopicId].returnList.length" [pageSize]="pageSize" (page)="onPageChanged($event, topicList[activeTopicId].returnList)"></mat-paginator>
       </div>
      </div>
    </div>
  </ng-template>
  <!--Asset Allocation Data Content-->
  <ng-template [ngIf]="assetCheck">
    <div class="col-9 answer-section">
      <div class="article-heading2">Asset Allocation</div>
      <div class="asset-date-filter-content align-h">
        <!--From Date-->
        <div class="form-group">
          <mat-form-field>
            <input
                type="text"
                placeholder="From"
                matInput
                [matDatepicker]="picker1"
                [(ngModel)]="range.start"
                name="start"
                [max]="today"
            >
            <mat-datepicker-toggle
                matSuffix
                [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker
                #picker1
                color="primary"
            ></mat-datepicker>
        </mat-form-field>
        </div>
        <!--To Date-->
        <div class="form-group">
          <mat-form-field>
              <input
                  type="text"
                  placeholder="To"
                  matInput
                  [matDatepicker]="picker2"
                  [(ngModel)]="range.end"
                  name="end"
                  [max]="today"
                  [min]="range.start"
              >
              <mat-datepicker-toggle
                  matSuffix
                  [for]="picker2"
              ></mat-datepicker-toggle>
              <mat-datepicker
                  #picker2
                  color="primary"
              ></mat-datepicker>
          </mat-form-field>
      </div>
        <span class="material-icons asset-date-range-search" (click)="dateRangeSearch()">search</span>
      </div>
      <div class="asses-table-download margin-bottom-10" *ngIf="data.length > 0">
        <button mat-raised-button class="mat-button-small" type="button" color="primary" (click)="downloadAssestAllocation()">Download.xls</button>
      </div>
      <ng-template [ngIf]="data.length > 0">
      <table  class="table" [svData]="data" #sv="svDataTable" [svRowsOnPage]="5" svSortBy="name" svSortOrder="asc">
        <thead>
          <tr>
            <th>Fund Name</th>
            <th>Date</th>
            <th>Net Equity</th>
            <th>Arbitrage</th>
            <th>Debt and Cash</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of sv.data">
            <td>{{item.scheme}}</td>
            <td>{{item.date | date: 'dd-MMM-yyyy' }}</td>
            <td>{{item.netequity | number : '1.2-2'}} %</td>
            <td>{{item.arbitrage | number : '1.2-2'}} %</td>
            <td>{{item.debtandcash | number : '1.2-2'}} %</td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="6" class="center-paginator">
              <sv-bootstrap-paginator> </sv-bootstrap-paginator>
            </td>
          </tr>
        </tfoot>
      </table>
    </ng-template>
    <ng-template [ngIf]="data.length === 0">
      <p class="asset-date-range-no-data">No Data !!!</p>
    </ng-template>
    </div>
  </ng-template> 
  </div>
</div>

<!--Mobile View-->
<div class="downloads-main downloads-main-mobile content-mobile-section">
  <div class="col-12 pr-0 mr-0 row" *ngIf="topicList.length>0">
    <div class="col-12 pr-0 mr-0 tabs-section">
      <div *ngFor="let item of topicList;let i=index">
        <div class="question-tabs cursor-pointer" (click)="setActiveTopic(i)"
          [ngClass]="{'active-tab-button2':i===activeTopicId && !assetCheck}">
          <a class="tab-btn-text2">{{item.topic}}
            <span class="fa fa-angle-down arrow-indicator" *ngIf="activeTopicId!==i"></span>
            <span class="fa fa-angle-up arrow-indicator" *ngIf="activeTopicId===i"></span>
          </a>
          <div class="answwer-content" *ngIf="activeTopicId===i">
            <div *ngFor="let subItem of activePageDataChunk">
              <div class="col-12 pr-0 mr-0">
                <div class="col-12 pr-0 mr-0">
                  <div class="col-12 pr-0 mr-0 row file-list-section pt-3 pb-3">
                    <div class="col-8 p-0 mr-0">
                      <div class="text-answer-section">{{subItem.fileName}} </div>
                    </div>
                    <div class="col-4 pr-0 mr-0">
                      <img src="assets/icons/icon_view.png" class="view-img cursor-pointer" (click)=viewFile(subItem.url)>
                      &nbsp; <span class="tab-seperator"></span> &nbsp;
                        <file-download [path]="item.url"></file-download>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <mat-paginator class="paginator-bg" [length]="topicList[activeTopicId].returnList.length" [pageSize]="pageSize" (page)="onPageChanged($event, topicList[activeTopicId].returnList)"></mat-paginator>
          </div>
        </div>
      </div>
      <!--Asset Allocation-Mobile-->
      <div class="question-tabs cursor-pointer" [ngClass]="{'active-tab-button2':assetCheck}">
           <!--Asset Allocation Data Content-->
            <ng-template [ngIf]="assetCheck">
              <div class="col-9 answer-section">
                <div class="asset-date-filter-content-mobile align-h">
                  <!--From Date-->
                  <div class="form-group">
                    <mat-form-field>
                      <input
                          type="text"
                          placeholder="From"
                          matInput
                          [matDatepicker]="picker1"
                          [(ngModel)]="range.start"
                          name="start"
                          [max]="today"
                      >
                      <mat-datepicker-toggle
                          matSuffix
                          [for]="picker1"
                      ></mat-datepicker-toggle>
                      <mat-datepicker
                          #picker1
                          color="primary"
                      ></mat-datepicker>
                  </mat-form-field>
                  </div>
                  <!--To Date-->
                  <div class="form-group">
                    <mat-form-field>
                        <input
                            type="text"
                            placeholder="To"
                            matInput
                            [matDatepicker]="picker2"
                            [(ngModel)]="range.end"
                            name="end"
                            [max]="today"
                            [min]="range.start"
                        >
                        <mat-datepicker-toggle
                            matSuffix
                            [for]="picker2"
                        ></mat-datepicker-toggle>
                        <mat-datepicker
                            #picker2
                            color="primary"
                        ></mat-datepicker>
                    </mat-form-field>
                </div>
                  <span class="material-icons asset-date-range-search" (click)="dateRangeSearch()">search</span>
                </div>

                <ng-template [ngIf]="data.length > 0">
                <div class="col-lg-12 mobile-table">
                <table class="table" [svData]="data" #sv="svDataTable" [svRowsOnPage]="5" svSortBy="name" svSortOrder="asc">
                  <thead>
                    <tr>
                      <th>Fund Name</th>
                      <th>Date</th>
                      <th>Net Equity</th>
                      <th>Arbitrage</th>
                      <th>Debt and Cash</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of sv.data">
                      <td>{{item.scheme}}</td>
                      <td>{{item.date}}</td>
                      <td>{{item.netequity}}</td>
                      <td>{{item.arbitrage}}</td>
                      <td>{{item.debtandcash}}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="6" class="center-paginator">
                        <sv-bootstrap-paginator> </sv-bootstrap-paginator>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              </ng-template>
              <ng-template [ngIf]="data.length == 0">
                <p class="asset-date-range-no-data">No Data !!!</p>
              </ng-template>
              <div class="asses-table-download margin-bottom-10" *ngIf="data.length > 0">
                <button mat-raised-button class="mat-button-small" type="button" color="primary" (click)="downloadAssestAllocation()">Download.xls</button>
              </div>
              </div>
            </ng-template> 
      </div>
    </div>
  </div>
</div>
